// Generated by @sgflabs/opticomm-sdk-codegen. Do not edit.
// Run `yarn workspace @sgflabs/opticomm-sdk-codegen generate` after changing a backend route.
import { buildPath } from "../../core/path.js";
export const createVendorCustomerGroups = (client) => ({
    /**
     * `POST /vendor/customer-groups`
     *
     * The response is not yet typed — pass a type argument to narrow it,
     * or add an entry to TYPE_OVERRIDES in the codegen package.
     *
     * @operationId VendorCreateCustomerGroup
     * @source packages/modules/b2c-core/src/api/vendor/customer-groups/route.ts
     */
    create: (body, query, headers) => client.fetch("/vendor/customer-groups", { method: "POST", body, query, headers }),
    /**
     * `POST /vendor/customer-groups/:id/customers`
     *
     * The response is not yet typed — pass a type argument to narrow it,
     * or add an entry to TYPE_OVERRIDES in the codegen package.
     *
     * @operationId VendorUpdateCustomersInCustomerGroup
     * @source packages/modules/b2c-core/src/api/vendor/customer-groups/[id]/customers/route.ts
     */
    createCustomer: (id, body, query, headers) => client.fetch(buildPath("/vendor/customer-groups/:id/customers", [id]), { method: "POST", body, query, headers }),
    /**
     * `DELETE /vendor/customer-groups/:id`
     *
     * The response is not yet typed — pass a type argument to narrow it,
     * or add an entry to TYPE_OVERRIDES in the codegen package.
     *
     * @operationId VendorDeleteCustomerGroupById
     * @source packages/modules/b2c-core/src/api/vendor/customer-groups/[id]/route.ts
     */
    delete: (id, body, query, headers) => client.fetch(buildPath("/vendor/customer-groups/:id", [id]), { method: "DELETE", body, query, headers }),
    /**
     * `GET /vendor/customer-groups`
     *
     * The response is not yet typed — pass a type argument to narrow it,
     * or add an entry to TYPE_OVERRIDES in the codegen package.
     *
     * @operationId VendorListCustomerGroups
     * @source packages/modules/b2c-core/src/api/vendor/customer-groups/route.ts
     */
    list: (query, headers) => client.fetch("/vendor/customer-groups", { method: "GET", query, headers }),
    /**
     * `GET /vendor/customer-groups/:id`
     *
     * The response is not yet typed — pass a type argument to narrow it,
     * or add an entry to TYPE_OVERRIDES in the codegen package.
     *
     * @operationId VendorGetCustomerGroupById
     * @source packages/modules/b2c-core/src/api/vendor/customer-groups/[id]/route.ts
     */
    retrieve: (id, query, headers) => client.fetch(buildPath("/vendor/customer-groups/:id", [id]), { method: "GET", query, headers }),
    /**
     * `POST /vendor/customer-groups/:id`
     *
     * The response is not yet typed — pass a type argument to narrow it,
     * or add an entry to TYPE_OVERRIDES in the codegen package.
     *
     * @operationId VendorUpdateCustomerGroup
     * @source packages/modules/b2c-core/src/api/vendor/customer-groups/[id]/route.ts
     */
    update: (id, body, query, headers) => client.fetch(buildPath("/vendor/customer-groups/:id", [id]), { method: "POST", body, query, headers }),
});
//# sourceMappingURL=customer-groups.js.map